import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import memoizeOne from 'memoize-one';
import { uniqBy, groupBy } from '@elliemae/ds-utilities/utils';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getFieldValue = function getFieldValue(_ref) {
  var id = _ref.id,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === void 0 ? false : _ref$fixed,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$customValue = _ref.customValue,
      customValue = _ref$customValue === void 0 ? undefined : _ref$customValue,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      rest = _objectWithoutProperties(_ref, ["id", "fixed", "value", "customValue", "options"]);

  return _objectSpread(_objectSpread({}, rest), {}, {
    id: id,
    fixed: fixed,
    options: options,
    value: customValue || value
  });
};

var getGroupedFilterValues = function getGroupedFilterValues(result, values) {
  var _ref2 = values.length ? values[0] : {},
      group = _ref2.group,
      label = _ref2.label,
      options = _ref2.options;

  return [].concat(_toConsumableArray(result), [{
    type: options ? 'dropdown' : 'default',
    group: group,
    label: label,
    values: values.map(getFieldValue)
  }]);
};

var prepareFilters = memoizeOne(function (filters) {
  var uniqFilters = uniqBy(filters, function (v) {
    return [v.group, v.value].join();
  });
  var groupedFiltersObject = groupBy(uniqFilters, function (filter) {
    return "".concat(filter.group, "-").concat(!!filter.options);
  });
  return Object.keys(_objectSpread(_objectSpread({}, groupedFiltersObject.all && {
    all: groupedFiltersObject.all
  }), groupedFiltersObject)).map(function (key) {
    return groupedFiltersObject[key];
  }).reduce(getGroupedFilterValues, []);
});

export { prepareFilters };
//# sourceMappingURL=transformFilters.js.map
